import React from 'react';
import classNames from 'classnames';

/** PDF 기록부 스타일 체크박스 */
export const WheelReportCheck = ({ checked = false, label }) => (
  <span className="wheel-report-check-item">
    <span
      className={classNames('wheel-report-box', { 'wheel-report-box--checked': checked })}
      aria-hidden
    />
    {label && <span>{label}</span>}
  </span>
);

export const WheelReportCheckGroup = ({ options = [], value }) => {
  const isChecked = (optValue) =>
    Array.isArray(value) ? value.includes(optValue) : value === optValue;

  return (
    <span className="wheel-report-check-group">
      {options.map(({ label, value: optValue }) => (
        <WheelReportCheck
          key={optValue}
          label={label}
          checked={isChecked(optValue)}
        />
      ))}
    </span>
  );
};
